<div class="rate" >
    <div *ngIf="!finishedRating" class="rate-title">{{lang.data['block.rate.title']}}</div>

    <div class="rate-actions" *ngIf="!showFeedback">
        <div class="rate-negative rate-action pointer" (click)="rateArticle()">
            {{ lang.data['general.no']}}
        </div>
        <div class="rate-positive rate-action pointer" (click)="rateArticle(1)">
            {{ lang.data['general.yes']}}
        </div>
    </div>

    <div class="rate-feedback" *ngIf="showFeedback && !finishedRating">
        <ion-textarea placeholder="{{lang.data['block.rate.feedback_placeholder']}}" [(ngModel)]="feedback"></ion-textarea>
        <ion-button class="button-gray" shape="round" expand="full" (click)="sendFeedback()">
            {{lang.data['block.rate.send_feedback']}}
        </ion-button>
    </div>

    <div class="confirm-feedback" *ngIf="finishedRating">
        {{lang.data['feedback.confirmation']}}
    </div>
</div>
